import ORTable from "../../../../static/images/home_cards/or-table.svg";
import ProteinNeeds from "../../../../static/images/home_cards/protein-needs.svg";
import TablePads from "../../../../static/images/home_cards/table-pads.svg";
import StretcherPad from "../../../../static/images/home_cards/stretcher-pads.svg";
import AffinityI from "../../../../static/images/home_cards/table_pads/affinity_I.png";
import AffinityII from "../../../../static/images/home_cards/table_pads/affinity_II.png"
import AffinityIII from "../../../../static/images/home_cards/table_pads/affinity_III.png";
import AffinityIIIVCutout from "../../../../static/images/home_cards/table_pads/affinity_III_V_cutout.png";
import AlphaMaxx from "../../../../static/images/home_cards/table_pads/alpha_max.png";
import Amsco1080 from "../../../../static/images/home_cards/table_pads/amsco_1080.png";
import Amsco2080 from "../../../../static/images/home_cards/table_pads/amsco_2080.png";
import Amsco3080NoCutout from "../../../../static/images/home_cards/table_pads/amsco_3080_no_cutout.png";
import Amsco3080WithCutout from "../../../../static/images/home_cards/table_pads/amsco_3080_cutout.png";
import Amsco4085 from "../../../../static/images/home_cards/table_pads/amsco_4085.png";
import Amsco5085 from "../../../../static/images/home_cards/table_pads/amsco_5085.png";
import Berchtold810 from "../../../../static/images/home_cards/table_pads/berchtold_810.png";
import Berchtold850 from "../../../../static/images/home_cards/table_pads/berchtold_850.png";
import CMax from "../../../../static/images/home_cards/table_pads/c_max.png";
import Maquet1132AlphaStar from "../../../../static/images/home_cards/table_pads/maquet_1132_alpha_star.png";
import Midmark7100 from "../../../../static/images/home_cards/table_pads/midmark_7100.png";
import Midmark7300 from "../../../../static/images/home_cards/table_pads/midmark_7300.png";
import Shampaine1400 from "../../../../static/images/home_cards/table_pads/shampaine_1400.png";
import Shampaine4900 from "../../../../static/images/home_cards/table_pads/shampaine_4900.png";
import Skytron3100 from "../../../../static/images/home_cards/table_pads/skytron_3100.png";
import Skytron3500 from "../../../../static/images/home_cards/table_pads/skytron_3500.png";
import Skytron3600 from "../../../../static/images/home_cards/table_pads/skytron_3600.png";
import Skytron50006000 from "../../../../static/images/home_cards/table_pads/skytron_5000_6000.png";
import Skytron500160016500 from "../../../../static/images/home_cards/table_pads/skytron_5001_6001_6500.png";
import Skytron6600 from "../../../../static/images/home_cards/table_pads/skytron_6600.png";
import Skytron67006701 from "../../../../static/images/home_cards/table_pads/skytron_6700_6701.png";


export const VIEW = {
  MAIN: "MAIN",
  PROTEIN_CALCULATOR: "PROTEIN_CALCULATOR",
  REC_PROTEIN: "REC_PROTEIN",
  PROTEIN_FINAL_VIEW: "PROTEIN_FINAL_VIEW",
  OR_STRETCHER_VIEW: "OR_STRETCHER_VIEW",
  TABLE_PAD_VIEW: "TABLE_PAD_VIEW",
  TABLE_PAD_FINAL_VIEW: "TABLE_PAD_FINAL_VIEW",
  STRETCHER_PAD_VIEW: "STRETCHER_PAD_VIEW",
};

export const VIEW_META = {
  [VIEW.PROTEIN_CALCULATOR]: { label: "Protein Needs Calculator", parent: VIEW.MAIN },
  [VIEW.REC_PROTEIN]: { label: "Recommendation", parent: VIEW.PROTEIN_CALCULATOR },
  [VIEW.PROTEIN_FINAL_VIEW]: { label: "Summary", parent: VIEW.REC_PROTEIN },

  [VIEW.OR_STRETCHER_VIEW]: { label: "O.R. Table & Stretcher Pads", parent: VIEW.MAIN },
  [VIEW.TABLE_PAD_VIEW]: { label: "Table Pads", parent: VIEW.OR_STRETCHER_VIEW },
  [VIEW.TABLE_PAD_FINAL_VIEW]: { label: "Pad Details", parent: VIEW.TABLE_PAD_VIEW },
  [VIEW.STRETCHER_PAD_VIEW]: { label: "Stretcher Pads", parent: VIEW.OR_STRETCHER_VIEW },
};

export const ROOT_CRUMB = { view: VIEW.MAIN, label: "Clinical Resources" };

export const buildBreadcrumbTrail = (view) => {
  const trail = [];
  let current = view;
  while (current && current !== VIEW.MAIN) {
    trail.unshift({ view: current, label: VIEW_META[current]?.label || "" });
    current = VIEW_META[current]?.parent;
  }
  trail.unshift(ROOT_CRUMB);
  return trail;
};

export const RESOURCE_FLOWS = {
  protein: {
    entryView: VIEW.PROTEIN_CALCULATOR,
    views: [VIEW.PROTEIN_CALCULATOR, VIEW.REC_PROTEIN, VIEW.PROTEIN_FINAL_VIEW],
    title: "Protein Needs Calculator",
  },
  stretcherPads: {
    entryView: VIEW.OR_STRETCHER_VIEW,
    views: [VIEW.OR_STRETCHER_VIEW, VIEW.TABLE_PAD_VIEW, VIEW.TABLE_PAD_FINAL_VIEW, VIEW.STRETCHER_PAD_VIEW],
    title: "O.R. Table & Stretcher Pads",
  },
};

export const CLINICAL_RESOURCES_LIST = [
  {
    key: "stretcherPads",
    label: "O.R. Table & Stretcher Pads",
    icon: ORTable,
  },
  {
    key: "protein",
    label: "Protein Needs Calculator",
    icon: ProteinNeeds,
  },
];

export const OR_AND_STRECHER_LIST = [
  {
    key: "tablePads",
    label: "Table Pads",
    icon: TablePads,
    disabled: true,
  },
  {
    key: "stretcherPads",
    label: "Stretcher Pads",
    icon: StretcherPad,
  },
];

export const TABLE_PAD_LIST = [
  {
    modelName: "Affinity I",
    image: AffinityI
  },
  {
    modelName: "Affinity II",
    image: AffinityII
  },
  {
    modelName: "Affinity III",
    image: AffinityIII
  },
  {
    modelName: "Affinity III, With V-Cutout",
    image: AffinityIIIVCutout
  },
  {
    modelName: "AlphaMaxx®",
    image: AlphaMaxx
  },
  {
    modelName: "Amsco® 1080",
    image: Amsco1080
  },
  {
    modelName: "Amsco 2080",
    image: Amsco2080
  },
  {
    modelName: "Amsco 3080, no cutout",
    image: Amsco3080NoCutout
  },
  {
    modelName: "Amsco 3080, with cutout / Amsco 3085",
    image: Amsco3080WithCutout
  },
  {
    modelName: "Amsco 4085",
    image: Amsco4085
  },
  {
    modelName: "Amsco 5085",
    image: Amsco5085
  },
  {
    modelName: "Berchtold 810",
    image: Berchtold810
  },
  {
    modelName: "Berchtold 850",
    image: Berchtold850
  },
  {
    modelName: "C-Max",
    image: CMax
  },
  {
    modelName: "Maquet 1132 Alpha Star",
    image: Maquet1132AlphaStar
  },
  {
    modelName: "Midmark 7100",
    image: Midmark7100
  },
  {
    modelName: "Midmark 7300",
    image: Midmark7300
  },
  {
    modelName: "Shampaine 1400",
    image: Shampaine1400
  },
  {
    modelName: "Shampaine 4900",
    image: Shampaine4900
  },
  {
    modelName: "Skytron® 3100",
    image: Skytron3100
  },
  {
    modelName: "Skytron 3500",
    image: Skytron3500
  },
  {
    modelName: "Skytron 3600",
    image: Skytron3600
  },
  {
    modelName: "Skytron 5000/6000",
    image: Skytron50006000
  },
  {
    modelName: "Skytron 5001/6001/6500",
    image: Skytron500160016500
  },
  {
    modelName: "Skytron 6600",
    image: Skytron6600
  },
  {
    modelName: "Skytron 6700/6701",
    image: Skytron67006701
  },
];

export const toOptions = (values) => values.map((v) => ({ key: v, value: v }));

export const TABLE_PAD_HEIGHT_OPTIONS = toOptions([`3" (7.6 cm)`, `4" (10.2 cm)`]);

export const TABLE_PAD_STYLE_OPTIONS = toOptions(["Advantage Hi-Res", "Advantage Visco", "Advantage Visco/Gel"]);

export const TABLE_PAD_COVER_OPTIONS = toOptions(["Standard", "Chemical Resistant ARMORGUARD", "Both"]);

// TODO: replace with the actual full hardcoded lists for stretcher pads.
export const STRETCHER_WIDTH_OPTIONS = toOptions([`24" (61 cm)`, `25" (63.5 cm)`, `26" (66 cm)`, `27" (68.6 cm)`, `28" (71 cm)`, `29" (73.7 cm)`, `30" (76.2 cm)`]);
export const STRETCHER_LENGTH_OPTIONS = toOptions([`74" (188 cm)`, `75" (190.5 cm)`, `76" (193 cm)`, `78" (198 cm)`]);
export const STRETCHER_STYLE_OPTIONS = toOptions(["Advantage Hi-Res", "Advantage Visco"]);
export const STRETCHER_THICKNESS_OPTIONS = toOptions([`2" (5 cm)`, `3" (7.6 cm)`, `4" (10.2 cm)`, `5" (12.7 cm)`]);
export const STRETCHER_CORNER_OPTIONS = toOptions([`Square`, `Rounded`, `6" (15.2 cm) Angled`, `12" (30.5 cm) Angled`, `12" (30.5 cm) Angled Top & Rounded Bottom`  ]);

export const DISCLAIMER_TEXT = (
  <>
    The contents of this application, <strong>Medline Skin Health</strong>, including text, graphics, images, and other materials on this application
    are for informational purposes only. The contents are not intended to replace professional medical advice, diagnosis, or treatment. Always seek
    the advice of a physician or other qualified health provider with any questions you may have regarding a medical condition, treatment, or medical
    diagnosis. Do not disregard professional medical advice or delay medical attention because of information you viewed on the{" "}
    <strong>Medline Skin Health app.</strong>
  </>
);
